exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".current-music-needs {\n  width: 80%; }\n  .current-music-needs span {\n    font-family: 'Klavika', 'Quicksand', 'Lato', 'Arial', sans-serif, 'FontAwesome' !important;\n    color: #4a4a4a !important; }\n", ""]);

